
import { inject, ref } from 'vue'

import type {
    UploadInstance,
    UploadProps,
} from "element-plus";

//services
import JwtService from "@/core/services/JwtService";
import { showNotification, showMessage, validFormatImg } from "@/core/config/Tools"

import Swal from "sweetalert2/dist/sweetalert2.min.js";

export default {
    emits: ["processResponse"],
    setup(props, {emit}) {

        const dialogPhoto = inject<any>('dialogPhoto')
        const gblDataPhoto = inject<any>('gblDataPhoto')
        const urlUpload = ref(process.env.VUE_APP_API_URL)
        const upload = ref<UploadInstance>()
        const headers = ref({
            Authorization: `Bearer ${JwtService.getToken()}`
        })

        const beforeUpload: UploadProps['beforeUpload'] = (rawFile) => {
            if (!validFormatImg(rawFile.type)) {
                showMessage({title: '', message: '¡El archivo seleccionado debe ser en formato indicado!', status: 'error' })   
                return false
            } else if (rawFile.size > (500 * 1024)) {
                showMessage({title: '', message: '!El archivo seleccionado supera los tamaño indicado!', status: 'error' })
                return false
            }
            return true
        };

        const handleError: UploadProps['onError'] = (error: Error, uploadFile) => {
            const e = JSON.parse(error.message);
            Swal.fire({
                title: `Error [${e.status}]`,
                text: e.messages.error,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Intentar otra vez!",
                customClass: {
                        confirmButton: "btn fw-bold btn-light-danger",
                },
            });
        }

        const handleSuccess: UploadProps['onSuccess'] = (response, uploadFile) => {
            showNotification(response)
            emit("processResponse", response)
        }

        const onClosed = () => {
            upload.value!.clearFiles()
            gblDataPhoto.value = {}
        }

        return {
            dialogPhoto,
            gblDataPhoto,
            upload,
            headers,
            urlUpload,
            //methods
            handleError,
            beforeUpload,
            handleSuccess,
            onClosed

        }
        
    },
}
